import React, { useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import useFormField from '@hooks/useFormField';
import { Form, Input } from 'antd';

import styles from './ColorPickerField.module.scss';

const ColorPickerField = ({
    label,
    name,
    formItemProps,
    fieldProps,
    ...props
}) => {
    const { rules } = useFormField(props);

    return (
        <Form.Item
            label={label}
            name={name}
            validateFirst
            rules={rules}
            {...formItemProps}
        >
            <SketchPickerWrapper {...fieldProps} />
        </Form.Item>
    );
};

function SketchPickerWrapper({ value = '#1677ff', onChange, disabled, onOpen, onClose, width, height, swatchWidth, ...props }) {
    const [ displayColorPicker, setDisplayColorPicker ] = useState(false);
    const [ popoverStyle, setPopoverStyle ] = useState({});
    const swatchRef = useRef(null);

    const onOpenPopover = () => {
        if (swatchRef.current) {
            const rect = swatchRef.current.getBoundingClientRect();
            setPopoverStyle({
                position: 'fixed',
                top: rect.bottom + 4,
                left: rect.left,
                zIndex: 100000,
            });
        }
        setDisplayColorPicker(true);
        onOpen?.();
    };

    const onChangeColor = (color) => {
        onChange?.(color.hex);
    };

    const onClosePopover = () => {
        setDisplayColorPicker(false);
        onClose?.();
    };

    return (
        <div className={styles.colorPicker}>
            <div
                className={`${styles.swatch} ${disabled ? styles.disabled : ''}`}
                ref={swatchRef}
                onClick={disabled ? undefined : onOpenPopover}
                style={{ width: swatchWidth }}
            >
                <div 
                    style={{ width: width || '100%', height: height ?? 16, backgroundColor: disabled ? '#ccc' : value }} 
                    className={styles.color} 
                />
            </div>
            {displayColorPicker ? (
                <div className={styles.popover} style={popoverStyle}>
                    <div className={styles.cover} onClick={onClosePopover} />
                    <SketchPicker {...props} color={value || '#1677ff'} onChange={onChangeColor} />
                </div>
            ) : null}
        </div>
    );
}

export default ColorPickerField;
